import React from "react";

const RISK_CONFIG = {
  HIGH:   { pill: "pill-high",   score: "score-red",   accent: "#e24b4a", dot: "#e24b4a" },
  MEDIUM: { pill: "pill-medium", score: "score-amber",  accent: "#ba7517", dot: "#ba7517" },
  LOW:    { pill: "pill-low",    score: "score-green",  accent: "#1a9e78", dot: "#1a9e78" },
};

const VesselScoreCard = ({ vessel }) => {
  const cfg = RISK_CONFIG[vessel.risk] || RISK_CONFIG.LOW;
  return (
    <div className="frm-card">
      <div className="vsc-accent" style={{ background: cfg.accent }} />
      <div className="vsc-body">
        <div className="vsc-header">
          <div>
            <div className="vsc-name">{vessel.name}</div>
            <div className={`vsc-risk-pill ${cfg.pill}`}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot, display: "inline-block" }} />
              {vessel.risk} RISK
            </div>
            <div className="vsc-desc">{vessel.desc}</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div className={`score-circle ${cfg.score}`}>{vessel.score}</div>
            <div className="score-label">RISK SCORE</div>
          </div>
        </div>
        <div className="vsc-metrics">
          <div>
            <div className="vsc-met-val">{vessel.openItems}</div>
            <div className="vsc-met-lbl">Open Items</div>
          </div>
          <div>
            <div className="vsc-met-val">{vessel.exposure}</div>
            <div className="vsc-met-lbl">Exposure</div>
          </div>
          <div>
            <div className="vsc-met-val savings">{vessel.savings}<span style={{ fontSize: 9 }}>/mo</span></div>
            <div className="vsc-met-lbl">Savings</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VesselScoreCard;